import { api } from 'dicomweb-client';
import { DICOMWeb } from '@ohif/core';
import { createStudyInfoFromResult } from './qidoResponseUtils';
import { getQIDOQueryParams } from './qidoQueryUtils';


const errorHandler = {
  getHTTPErrorHandler: () => null,
};


function resultDataToStudies(resultData) {
  const studies = [];

  if (resultData && resultData.length) {
    resultData.forEach((studyResult) => {
      try {
        const studyInfo = createStudyInfoFromResult(studyResult);
        studies.push(studyInfo);
      } catch (e) {
        console.error('Error parsing study results: ', e);
      }
    });
  }

  return studies;
}

export default async function searchStudies(server, queryFilters, PACS_WITHOUT_WILDCARD = false) {
  const dicomWeb = new api.DICOMwebClient({
    url: server.qidoRoot,
    headers: DICOMWeb.getAuthorizationHeader(server),
    errorInterceptor: errorHandler.getHTTPErrorHandler(),
  });

  server.qidoSupportsIncludeField = server.qidoSupportsIncludeField === undefined ? true : server.qidoSupportsIncludeField;

  const resultData = await dicomWeb.searchForStudies({
    queryParams: getQIDOQueryParams(queryFilters, server.qidoSupportsIncludeField, PACS_WITHOUT_WILDCARD),
  });

  return resultDataToStudies(resultData);
}
